<template>
  <b-row id="images">
      <div class="dropbox image-box">
        <input type="file" multiple :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length" accept="image/*" class="input-file">
          <div v-if="isSaving" class="uploading-icon"></div>
          <!-- <div v-if="isSaving" class="dropbox-desc">
            <p>Uploading {{ fileCount }} files...</p>
          </div> -->
          <div v-else class="dropbox-desc">
            <p>Add Media <i class="el-icon-plus add-icon"></i></p>
            <i>Drag your files here or click</i>
          </div>
      </div>
      <div v-for="holder in tempImageHolders" :key="holder.id" style="position: relative;" class="image-preview-container image-box">
        <b-progress  v-if="holder.temp" :value="holder.progress" :max="100" show-progress animated></b-progress>
        <i v-if="holder.progress===100 && isSaving" class="img-working-cover">Processing...</i>
        <img :src="holder.origImgUrl" :id="holder.id" class="photo-add-holder image">
        <md-button v-if="isSuccess || isInitial" @click="removeImage(holder.id)" class="show-when-parent-hover md-fab md-accent md-flat">
          <md-icon>delete_forever</md-icon>
        </md-button>
        <!-- <i v-if="isSuccess || isInitial" @click="removeImage(holder.id)" class="show-when-parent-hover"></i> -->
      </div>
  </b-row>
</template>

<script>
  import {
    uploadImages
  } from '../imageFunctions.js'
  const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;
  const MAX_FILE_MB = 5
  export default {
    props: {
      startWithImages: Array,
      onError: Function,
      onSuccess: Function,
      onProgress: Function
    },
    data() {
      return {
        snackbarText: "",
        showSnackbar: false,
        fileCount: 0,
        tempThumbHolder: new Object(),
        tempImageHolders: [],
        imageIdCounterGlobal: -1,
        processedThumbsCounterGlobal: 0,
        pictureUrls: [],
        thumbUrls: [],
        picAdded: false,
        currentStatus: STATUS_INITIAL,
      };
    },
    computed: {
      isInitial() {
        return this.currentStatus === STATUS_INITIAL;
      },
      isSaving() {
        if(this.currentStatus === STATUS_SAVING){
          return true
        }
      },
      isSuccess() {
        return this.currentStatus === STATUS_SUCCESS;
      },
      isFailed() {
        return this.currentStatus === STATUS_FAILED;
      },
    },
    created(){
      if(this.startWithImages && this.startWithImages.length > 0){
        for (var image of this.startWithImages) {
          this.imageIdCounterGlobal++
          var temp = {
            imgUrl: image.thumb,
            progress: 100,
            id: this.imageIdCounterGlobal,
            origImgUrl: image.url
          }
          this.tempImageHolders.push(temp)
        }
        this.processedThumbsCounterGlobal = this.tempImageHolders.length
        this.onProgress(STATUS_INITIAL, this.tempImageHolders)  //allows for user to move forward on parent side without additional image uploads
      }else{
        //this.onProgress(STATUS_SAVING)
      }
    },
    methods: {
      filesAreAllowed(files){
        var result = {success: false, message: ""}
        for (var i = 0; i < files.length; i++) {
          result = this.allowedMime(files[i])
          if(!result.success) return result
          result = this.allowedSize(files[i])
        }
        return result
      },
      allowedSize(file){
        if(file.size/1000000 > MAX_FILE_MB) return {success:false, message: "File too large, " + "max " + MAX_FILE_MB + "Mb allowed"}
        else return {success:true, message: ""}
      },
      allowedMime(file){
        if (file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/png') return {success:true, message: ""}
        else return {success:false, message: "File type not allowed"}
      },
      filesChange(fieldName, fileList) {
        this.onProgress(STATUS_SAVING)
        this.currentStatus = STATUS_SAVING
        try{
          var i;
          var sourceImages = []
          var count = fileList.length
          var fileCheckReport = this.filesAreAllowed(fileList)
          if(fileCheckReport.success){
            for (i = 0; i < fileList.length; i++) {

              var reader = new FileReader();
              this.imageIdCounterGlobal++
              // generate empty dom element
              this.tempImageHolders.push({id:this.imageIdCounterGlobal, imgUrl:'../static/Upload.png', progress: 5, temp:true, origImgUrl:'../static/Upload.png'})
              reader.onloadend = (function(source, imageId) {
                  return function(e) {
                    var sourceImg = document.getElementById(imageId);
                    if(sourceImg){
                      sourceImg.src = e.target.result;
                      sourceImages.push(sourceImg)

                      // wait until the src is actually loaded by the DOM (sourceImg.complete)
                      function completed() {
                        count--
                        if (count === 0) { // if all files have been loaded (no count / count==0)
                          source.processImageUpload(sourceImages)
                        }
                      }
                      sourceImg.addEventListener('load', completed)
                    }
                  };
              })(this, this.imageIdCounterGlobal);
              reader.readAsDataURL(fileList[i]);
            }
          }else{
            this.currentStatus = STATUS_INITIAL
            this.notifyUser(fileCheckReport.message)
          }
        }catch(err){
          this.onError(err)
        }
      },
      processImageUpload(images){
        uploadImages(images,
          this.tempImageHolders.slice(this.processedThumbsCounterGlobal, this.tempImageHolders.length),
          function(progress, id) {
          // callback doing nothing cause the progress is update inside the uploadImages()
        })
          .then(response => {
            this.processedThumbsCounterGlobal += response.length
            this.replaceTempUrlsWithUploadedImages(response)
            this.currentStatus = STATUS_SUCCESS
            //this.$parent.filesChange(fieldName, fileList)
            this.onSuccess(this.tempImageHolders)
          }, error => {
            console.log(error)
            this.onError(error)
          })
      },
      replaceTempUrlsWithUploadedImages(images){
        // loop over uploadedImages[{orig:'', thumb:''}, ...]
        // for each placeholder (temp:true) added,replace it with the real image
        //  reasoning: ideally there should be as many temporarys as there are new real images
        let realCounter = 0
        for(let holder of this.tempImageHolders){
          if(holder.temp){
            holder.imgUrl = images[realCounter].thumb;
            holder.temp = false;
            holder.origImgUrl = images[realCounter].orig;
            holder.aboutImage = images[realCounter].aboutImage

            realCounter++
          }
        }

      },
      removeImage(id) {
        var removeFromThisIndex = 0;
        for (var i = 0; i < this.tempImageHolders.length; i++) {
          if(this.tempImageHolders[i].id == id) {
            removeFromThisIndex = i
            break;
          }
        }
        this.tempImageHolders.splice(removeFromThisIndex, 1)
        this.processedThumbsCounterGlobal = this.tempImageHolders.length
      },
      notifyUser(msg){
        this.$notify({
          title: "Cannot upload file",
          message: msg
        })
      }
    }
  }
</script>
<style scoped>
  @import '../assets/styles/add-steps.css';
  @import '../assets/styles/images.css';
  @import '../assets/styles/global.css';


  .uploading-icon{
    background: url('../assets/uploading.svg') no-repeat;
    background-size: contain;
    height: 150px;
    width: 200px;
  }
  .add-icon{
    color: #506993;
    text-align: center;
  }

  .dropbox {
    outline: 2px dashed grey;
    color: dimgray;
    display: table;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    -ms-transition: all 0.3s ease;
  }
  .dropbox:hover {
    max-width: 240px;
    max-height: 160px;
  }

  .image-preview-container{
    background-color: #eaeaea80;
  }

  .dropbox-desc{
    vertical-align: middle;
    display: table-cell;
    text-align: center;
    height: 160px;
  }
  .dropbox-desc p{
    margin-bottom:0;
  }

  .input-file {
    opacity: 0; /* invisible but it's there! */
    position: absolute;
    cursor: pointer;
    max-width: 240px;
    height: 160px;
  }

  .dropbox p {
    font-size: 1.2em;
    text-align: center;
    padding: 50px 0;
  }
  .img-working-cover{
    width: 100%;
    height: 100%;
    position: absolute;
    color: grey;
    background-color: rgb(0,0,0,0.6);
    color: white;
    text-align: center;
    padding-top: 60px;
  }
  .show-when-parent-hover {
    opacity: 0;
    position: absolute;
    cursor: pointer;
    width: 55px;
    height: 55px;
    top: 25%;
    left: 38%;
  }
  /* .show-when-parent-hover {
    background: url('../assets/cancel_red.svg') no-repeat;
    opacity: 0;
    position: absolute;
    cursor: pointer;
    width: 55px;
    height: 55px;
    top: 35%;
    left: 38%;
  } */
  .add-image-icon {
    background: url('../assets/cameraadd.svg') no-repeat;
    cursor: pointer;
    display: inline-block;
    height: 100%;
    width: 100%;
  }
  .image-preview-container:hover .show-when-parent-hover{
    opacity: 1;
  }

  .image-preview-container:hover .photo-add-holder{
    opacity: 0.2
  }
  .img-upload-progress-bar{
  	height: 10%;
  	font-size: 0.75rem;
  	background-color: #e9ecef;
  	margin-left: 1em;
  	margin-right: 1em;
  	position: relative;
  	top: 45%;
  }



  .photo-add-holder {
    cursor: pointer;
  }

  .photo-add-holder li.el-upload-list{
    min-width: 244px;
    min-height: 156px;
  }

  .photo-uploded{
    padding: 15px;
  }
  #skip-add-img-btn{
    width: 100%;
    background: lightgrey;
    border:none;
  }
</style>



// WEBPACK FOOTER //
// src/components/multiImageUploader.vue